export default
    {
        // 获取新闻列表
        async getNewsList(params) {
            let actiontype = 'ArticleService_GetSimpleArticleList';
            return await this.fetch(actiontype, params);
        },
        // 获取新闻列表
        async getArticleInfo(params) {
            let actiontype = 'ArticleService_B2C_GetArticleInfoByTidHandler';
            return await this.fetch(actiontype, params);
        },
        // 获取新闻列表及副标题 
        async getArticleListWithParagraphs(params) {
            let actiontype = 'B2C_GetArticleListWithParagraphs';
            return await this.fetch(actiontype, params);
        }
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/news.js